import { Campaign, VideoType, VideoTypeEnum } from "../types";

export const campaignFileAccept = (type?: Campaign['type']) =>
    type === 'PHOTO' ? '.mp4' : type === 'PANORAMA' ? '.360' : '.mp4,.360';

export const validateCampaignFiles = (files: File[], type?: Campaign['type']): string | null => {
    const invalid = files.filter(file => {
        const name = file.name.toLowerCase();
        return !name.endsWith('.mp4') && !name.endsWith('.360') ||
            type === 'PHOTO' && !name.endsWith('.mp4') ||
            type === 'PANORAMA' && !name.endsWith('.360');
    });
    return invalid.length ? `Allowed files: ${campaignFileAccept(type)}. Incompatible files: ${invalid.map(file => file.name).join(', ')}` : null;
};

export const getVideoType = (filename: string): VideoType => {
    return filename.toLowerCase().endsWith('.360') ? VideoTypeEnum.PANORAMA : VideoTypeEnum.PHOTO;
};

export const isVideoTypeCompliantWithRecord = (fileType: string, recordType: string) => {
    if (recordType != "UNKNOWN" && fileType != recordType) {
        return false
    }
    return true
}

/**
 * Slugifies a video filename and lowercases its extension
 * Example: "My Video.TEST.MP4" → "my_video.test.mp4"
 */
export const slugifyFileName = (filename: string): string => {
    // Split into name and extension parts
    const lastDotIndex = filename.lastIndexOf('.');
    let name = filename;
    let extension = '';

    if (lastDotIndex > 0) {
        name = filename.substring(0, lastDotIndex);
        extension = filename.substring(lastDotIndex + 1);
    }

    // Slugify the name part
    const slugifiedName = name
        .normalize('NFD')                // Decompose accented characters
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
        .toLowerCase()                   // Convert to lowercase
        .replace(/\s+/g, '_')           // Replace spaces with _
        .replace(/[^\w]+/g, '')          // Remove all non-word chars except _
        .replace(/__+/g, '_')            // Replace multiple _ with single _
        .replace(/^_+/, '')              // Trim _ from start
        .replace(/_+$/, '');             // Trim _ from end

    // Lowercase the extension and recombine
    const lowercasedExtension = extension.toLowerCase();
    return lowercasedExtension
        ? `${slugifiedName}.${lowercasedExtension}`
        : slugifiedName;
};

// console.log(slugifyFileName("My Video.TEST.MP4"));  // "my_video.test.mp4"
// console.log(slugifyFileName("My Video.TEST.mp4"));
// console.log(slugifyFileName("My Vidéo.TEST.360"));
// console.log(slugifyFileName("Another.Video.avi"));  // "another.video.avi"
// console.log(slugifyFileName("NoExtension"));        // "noextension"
